const MENU_FETCH_SKIP_PATH_PREFIXES = ['/login', '/register'];

export const isMenuFetchSkippedPath = (pathname = '') =>
  MENU_FETCH_SKIP_PATH_PREFIXES.some((prefix) => pathname.startsWith(prefix));

export const shouldSkipMenuFetch = ({ pathname = '', isAlliancePath = false } = {}) =>
  Boolean(isAlliancePath || isMenuFetchSkippedPath(pathname));
